import { SearchTips } from 'es6/collections/search-tips'
import { normalizeQuery } from 'helpers/string-helpers'
import { isMobile } from 'init/is-mobile'
import { View } from 'es6/components/view'
import { SearchTipsView } from 'es6/views/search/search-tips-view'
import { getUrlParameter, getFilteredUrlParameters, to } from 'helpers/url-helpers'
import { locationAssign } from 'helpers/redirect-helper'
import { Defaults } from 'es-decorators'
import Backbone from 'init/backbone'
import remove from 'lodash/remove'
import { LS } from 'helpers/storage-helpers'
import { preventInputZoom } from 'helpers/dom-helper'

/**
 * Вид для строки поиска в шапке.
 */
@Defaults({
  el: '#search-form',
  router: false,
  collection: false,
  controlKeys: ['Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'],
  additionalOptions: ['router', 'collection'],

  events: {
    'click button': 'search',
    'keyup input.search-input': 'getTips',
    'click .js-help-tip': 'setHelpTipToInput',
    'click input.search-input': 'showTipsOnClick',
    'mousedown .search-input': preventInputZoom,
  },
  DEFAULT_SORT: 'rank',
  MAX_SAVED_REQUESTS: 10,
})
export class SearchBarView extends View {
  /**
   * @inheritDoc
   */
  run () {
    let sortField = this.$('input[name=sort]'),
      perPageField
    // Удаляем из формы сортировку всегда
    if (sortField.length) {
      sortField.remove()
    }
    if (this.collection && this.router) {
      // Если находимся на странице поиска, то также удаляем из формы "показывать по"
      perPageField = this.$('input[name=per-page]')
      perPageField.remove()
      this.listenTo(this.collection, 'in-stock', this.saveQueryToLS)
    }
    this.listenTo(Backbone, 'set-tip-to-input', this.setHelpTipToInput)
    this.listenTo(Backbone, 'show-search-history', this.showMobileSearchTips)
  }

  /**
   * Обрабатывает событие нажатия на кнопку
   * @param {Event} e Объект события
   */
  search (e) {
    e.preventDefault()
    e.stopPropagation()
    if (this.tips && this.tips instanceof SearchTipsView) {
      this.tips.abort()
    }

    let query = this.$el.serializeArray()[0],
      priorityKeys = ['priority_ids', 'priority_sids', 'priority_parent_ids'],
      params = getFilteredUrlParameters(priorityKeys)
    if (params.sort) {
      params.sort = this.DEFAULT_SORT
    }
    if (!this.collection && !this.router && params.f) {
      params.f = null
    }

    if (!query.name) {
      query = { name: 'q', value: '' }
    }
    query.value = normalizeQuery(query.value)
    params.q = encodeURIComponent(query.value)
    if (this.collection && this.router) {
      if (params.q) {
        /**
         * Сбрасываем фильтры если изменился запрос или категория поиска,
         * если ничего не изменилось, то сохраняем фильтры.
         */

        if (!isMobile && this.collection.query !== params.q) {
          params.f = null
        }
        this.router.navigate('/', {
          trigger: true,
        }, params)
      }
      return
    }
    locationAssign(to('/search', {}, params))
  }

  /**
   * Подставляет значение подсказки в инпут
   * @param {(jquery.Event|null)} event Событие
   * @param {string}              value Значение
   */
  setHelpTipToInput (event, value) {
    let isSetByEvent = event && event.currentTarget,
      searchQuery = isSetByEvent ? event.currentTarget.textContent : value
    this.$('input.search-input').val(searchQuery)
    if (isSetByEvent) {
      this.searchWithHelpTip()
    }
  }

  /**
   * Поиск с запросом равным значению подсказки, при клике по ней
   * @returns {boolean} false
   */
  searchWithHelpTip () {
    this.$('button').click()
    return false
  }

  /**
   * Инициализация view для подсказок
   */
  initTips () {
    if (!this.tips) {
      this.tips = new SearchTipsView({
        model: new SearchTips(),
        user: this.user,
      })
    }
    this.tips.setCurrentUrl('')
  }

  /**
   * Получение и показ подсказок
   * @param {Event} e
   */
  getTips (e) {
    if (this.validateKey(e)) {
      this.initTips()
      let q = normalizeQuery(this.$('input.search-input').val())
      this.resetState(q.length)
      this.tips.query(q)
    }
  }

  /**
   * Проверяем, подходит ли нажатая клавиша для набора запроса
   * @param {Event} e
   * @returns {boolean}
   */
  validateKey (e) {
    let isFKey = e.key && e.key.match(/F([0-9]{1,2})/)
    let withModifierKey = e.altKey || e.metaKey || e.ctrlKey || e.shiftKey
    let isModifierKey = ['Alt', 'Control', 'Shift', 'Meta'].includes(e.key)
    return !this.controlKeys.includes(e.key)
      && !isFKey
      && !withModifierKey
      && !isModifierKey
  }

  /**
   * Обновляет состояния открытых/закрытых категорий и брендов, вследствие обновления запроса в поиске
   * @param {string} q длина строки поиска
   */
  resetState (q) {
    if (q < 2) {
      this.tips.stateCountTips = false
      this.tips.stateTips.Trademarks = true
      this.tips.stateTips.Category = true
    }
  }

  /**
   * Сохраняем успешный поисковый запрос в LocalStorage.
   * @param {string} [query] поисковый запрос.
   *
   * @returns {Array} requests сохраненные поисковые запросы
   */
  saveQueryToLS (query) {
    let requests = LS.get('saved_requests') || [],
      link = location.href
    query = query || getUrlParameter('q')

    // убираем повторяющиеся запросы
    remove(requests, request => {
      return request.query === query
    })
    requests.unshift({
      link: `${link.split('?')[0]}?q=${query}`,
      query: query,
    })
    if (requests.length > this.MAX_SAVED_REQUESTS) {
      requests.pop()
    }
    LS.set(
      'saved_requests',
      requests,
      () => {
        localStorage.clear()
        LS.set('saved_requests', requests)
      },
    )
    return requests
  }

  /**
   * Обрабатывает клик на поисковую строку. Запускает подсказки на основе запросов.
   * @param {Event} event
   */
  showTipsOnClick (event) {
    event.stopPropagation()
    this.getTips({
      key: '',
    })
    if (this.tips) {
      this.tips.inputFocusedByUser = true
    }
  }

  /**
   * Показывает историю запросов на мобильной версии
   */
  showMobileSearchTips () {
    this.initTips()
    this.tips.renderRequests()
  }

  /**
   * Открывает себя
   */
  show () {
    this.closeManager()
  }

  /**
   * Закрывает себя или другие вью при пересечении
   */
  closeManager () {
    Backbone.trigger('close-search-bar')
  }
}
